import { environment } from 'src/environments/environment';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class AadhaarService {

	constructor(
		private apiService: ApiService
	) { }

	validateAdhaarNumber(aadharData) {
		// const cred = {
		// 	aadharEncryptedValue: btoa(adharNumber)
		// };
		const adhaarAPI = environment.aadharServiceURL +  '/api/aadharservice/v1/demographicVerifyAadhaarNumber';
		return this.apiService.post(adhaarAPI, aadharData);
	}
	getAdharNumber(_aadharKey) {
		const addharAPI = environment.aadharServiceURL + '/api/aadharservice/v1/demographicVerifyAadhaarNumber';

		return this.apiService.getWithHeader(addharAPI, _aadharKey);
	}

	validateAadharNumberV2(aadhaarData) {
		const adhaarAPI = environment.aadharServiceURL +  '/api/aadharservice/v1/demographicVerifyAadhaarNumber';
		return this.apiService.post(adhaarAPI, aadhaarData);
	}

	validateAadharRefById(payLoad) {
		const apiUrl = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/refKeyVerify`;
		return this.apiService.post(apiUrl, payLoad);
	}

	validateVirtualId(payload) {
		const virtualIdAPI = `${environment.aadharServiceURL}/api/aadharservice/v1/virtualAadhaarOtpRequest`;
		return this.apiService.post(virtualIdAPI, payload);
	}

	validateVirtualIdOTP(payload) {
		const virtualIdOTP = `${environment.aadharServiceURL}/api/aadharservice/v1/virtualAadhaarOtpVerified`;
		return this.apiService.post(virtualIdOTP, payload);
	}

	encryptData(data: string, key: string) {
		var encrypted = CryptoJS.AES.encrypt(data, key, {
			mode: CryptoJS.mode.CFB,
			padding: CryptoJS.pad.AnsiX923
		}).toString();
		return encrypted;
	}
	getDataEncryptor() {
		const adhaarAPI = environment.aadharServiceURL + '/api/aadharservice/v1/get/data';
		return this.apiService.get(adhaarAPI);
	}
	getDataEncryptorForNomination() {
		const adhaarAPI = environment.aadharServiceURL + '/api/aadharservice/v1/get/unauth/data';
		return this.apiService.get(adhaarAPI);
	}
	decodeKey(data: string){
		const decodedKey = CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
        return decodedKey;
	}
}
